import { Injectable } from '@angular/core';
import { Actions,createEffect,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of,throwError } from 'rxjs';
import { catchError,concatMap,map,switchMap,withLatestFrom } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { stringifyIfNotUndefined } from '../../../../helper/helper';
import { ContractParticipantEntity } from '../../../entities/mdqx/contract-participant.entity';
import { HttpService } from '../../../services/http.service';
import { DaveActions } from '../../actions/actions';
import { BaseActionTypes } from '../../actions/base.actions';
import { ContractParticipantActionTypes,DeleteContractParticipantResponse,GetContractParticipantsResponse,PostContractParticipantResponse } from '../../actions/mdqx/contract-participant.actions';
import { State } from '../../index';
import { getToken } from '../../selectors/base.selectors';

enum ErrorCodes {
    Get = 'Vertragsteilnehmer Abrufen fehlgeschlagen',
    Post = 'Vertragsteilnehmer Anlegen fehlgeschlagen',
    Delete = 'Vertragsteilnehmer Löschen fehlgeschlagen',
}

@Injectable()
export class ContractParticipantEffects {
    get$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ContractParticipantActionTypes.GetRequest),
            map(
                () => `
            {
                contractParticipant {
                    ${ContractParticipantEntity.GqlFields}
                }
            }`,
            ),
            withLatestFrom(this.store.select(getToken)),
            switchMap(([query, token]) =>
                this.api.graphQl({ query }, { token }, '', environment.mdqxGatewayApiUrl).pipe(
                    map((res) => res && res.contractParticipant),
                    concatMap((res) => (res ? [new GetContractParticipantsResponse(res.map((contractParticipant) => new ContractParticipantEntity(contractParticipant)))] : throwError('empty response'))),
                    catchError((err, caught) =>
                        of(
                            BaseActionTypes.ErrorAction({
                                Payload: {
                                    ToasterMessage: ErrorCodes.Get,
                                    Err: err,
                                    Caught: caught,
                                },
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    post$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ContractParticipantActionTypes.PostRequest),
            map(
                ({ Payload }) => `
            mutation {
                createContractParticipant(
                    contractId: ${JSON.stringify(Payload.contractId)}
                    customerId: ${JSON.stringify(Payload.customerId)}
                    ${stringifyIfNotUndefined(Payload, 'entryDate')}
                    ${stringifyIfNotUndefined(Payload, 'endDate')}
                    ${stringifyIfNotUndefined(Payload, 'ausnahmedatum')}
                ) {
                    ${ContractParticipantEntity.GqlFields}
                }
            }`,
            ),
            withLatestFrom(this.store.select(getToken)),
            concatMap(([query, token]) =>
                this.api.graphQl({ query }, { token }, '', environment.mdqxGatewayApiUrl).pipe(
                    map((res) => res && res.createContractParticipant),
                    concatMap((res) => (res ? [new PostContractParticipantResponse(new ContractParticipantEntity(res))] : throwError('empty response'))),
                    catchError((err, caught) =>
                        of(
                            BaseActionTypes.ErrorAction({
                                Payload: {
                                    ToasterMessage: ErrorCodes.Post,
                                    Err: err,
                                    Caught: caught,
                                },
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ContractParticipantActionTypes.DeleteRequest),
            withLatestFrom(this.store.select(getToken)),
            concatMap(([{ Payload }, token]) =>
                this.api
                    .graphQl(
                        {
                            query: `
                        mutation {
                            deleteContractParticipant(id: ${JSON.stringify(Payload.id)})
                        }`,
                        },
                        { token },
                        '',
                        environment.mdqxGatewayApiUrl,
                    )
                    .pipe(
                        map((res) => res && res.deleteContractParticipant),
                        concatMap((res) => (res ? [new DeleteContractParticipantResponse(Payload.id)] : throwError('falsy response'))),
                        catchError((err, caught) =>
                            of(
                                BaseActionTypes.ErrorAction({
                                    Payload: {
                                        ToasterMessage: ErrorCodes.Delete,
                                        Err: err,
                                        Caught: caught,
                                    },
                                }),
                            ),
                        ),
                    ),
            ),
        ),
    );

    constructor(private actions$: Actions<DaveActions>, private api: HttpService, private store: Store<State>) {}
}
